(ns ductile.ui.pred-view
  (:require [ductile.ui.components :as ui]
            [ductile.ui.locale :refer [tr]]))

(def color-classes
  {:blue ["bg-sky-50/60" "text-sky-700" "border-sky-200"]
   :violet ["bg-indigo-50/60" "text-indigo-700" "border-indigo-200"]})

(defn badge
  ([label] [badge {:color :blue} label])
  ([{:keys [color wrap?]} label]
   (into [:div.border.rounded-lg.font-mono.shadow
          {:style {:padding "2px 5px" :font-size "10px"}
           :class (conj (color-classes (or color :blue))
                        (if wrap? "whitespace-normal leading-tight" "whitespace-nowrap leading-none"))}]
         label)))

(defn nested-badge [{:keys [color]} & content]
  [:div.border.rounded-lg.font-mono.whitespace-nowrap.leading-none.shadow.inline-flex.items-center.gap-1.justify-start.self-start.place-items-start
   {:style {:font-size "10px"}
    :class (ui/class-vec (color-classes (or color :blue)) "[&_:hover:not(:has(:hover))]:bg-green-400/20")}
   (into [:div.px-1.inline-flex.items-center.gap-1.flex-wrap.justify-start.self-start.place-items-start.rounded-lg
          {:class "[&_:hover:not(:has(:hover))]:bg-green-400/20 py-[3px]"}]
         content)])

(defn explain-pred-atom [form]
  (or (when (keyword? form)
        (tr form))
      (str form)))

(defn explain-pred [pred]
  (cond
    (vector? pred) (interpose [badge {:color :violet} (tr "and")] (map explain-pred pred))

    (list? pred)
    (case (first pred)
      constantly (if (= [true] (rest pred))
                   (badge (tr "always"))
                   (nested-badge {} (tr "constantly") (map explain-pred (rest pred))))
      complement (nested-badge {} (tr "not") (map explain-pred (rest pred)))
      every-pred (nested-badge {} (interpose [badge {:color :violet} (tr "and")] (map explain-pred (rest pred))))
      some-fn (nested-badge {} (interpose [badge {:color :violet} (tr "or")] (map explain-pred (rest pred))))
      comp (nested-badge {} (interpose [ui/icon {:width 10 :height 10} :chevron-right]
                                       (map explain-pred (reverse (rest pred)))))
      fn (badge {:wrap? true} (pr-str pred))
      (nested-badge {}
                    (explain-pred-atom (first pred))
                    (map explain-pred (rest pred))))

    ;; Locations map-of {uuid, description}
    (and (map? pred) (every? uuid? (keys pred)) (every? string? (vals pred)))
    (map explain-pred (vals pred))

    :else
    (badge (explain-pred-atom pred))))
